import React from 'react';
import {
  appName,
  ClientChatTypes,
} from '@pharmaplan/common';

// eslint-disable-next-line import/no-unresolved
import { MessageHeaderProps } from '@sendbird/uikit-react/types/ui/MessageContent/MessageHeader';

import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';

const { pharmacist, pharmacy } = ClientChatTypes;

type senderTypeCast = {
  customType?: string;
  sender?: {
    userId: string;
  };
};

const SenderTitle = (props: MessageHeaderProps) => {
  const name = appName[ServiceHandler.getService()];

  return (
    <div className="sendbird-message-content__middle__sender-name sendbird-label sendbird-label--caption-2 sendbird-label--color-onbackground-2">
      {name}
    </div>
  );
};

export default SenderTitle;
